import { useEffect } from 'react';
import { useFormikContext } from 'formik';

import { ModalField, SetIsWidgetActive, ToggleModal } from '../../types';
import openModalByError from '../../utils/open-modal-by-error';

type UseOpenPanelOnErrorParams = {
  modalFields: ModalField[];
  setIsWidgetActive: SetIsWidgetActive;
  toggleModal: ToggleModal;
};

const UseOpenPanelOnError = ({ modalFields, toggleModal, setIsWidgetActive }: UseOpenPanelOnErrorParams) => {
  const { errors, isValid, isSubmitting } = useFormikContext();

  useEffect(() => {
    if (isSubmitting && !isValid) {
      openModalByError({ errors, modalFields, setIsWidgetActive, toggleModal });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValid, isSubmitting]);
};

export default UseOpenPanelOnError;
